export var getUrlServiceHref = function getUrlServiceHref(href) {
  return href && "/api/url?url=".concat(encodeURIComponent(href));
};